/* eslint-disable no-undef */
import $ from 'jquery';
import { RouteParams } from 'universal-router';
import { PublicPage } from '../PublicPage';
import "datatables.net";
import { Common } from '../all/common';

export class StorePage extends PublicPage {
    public static render(params: RouteParams): void {
        super.render(params);

        super._OpenMenu();
        StorePage._DataTable();
        StorePage._OpenMenuLateral();
        Common.openActionsBehaviour();
        StorePage._DragAndDrop();
    }

    private static _OpenMenuLateral() {
        const icon = $('.iconShowMenuLateral');
        const aside = $('aside');
        const content_aside = aside.find('.content_aside');

        icon.on("click", function () {
            if ($('body').hasClass('.page-product')) {

            }
            else {
                $('body').addClass("open_aside");
            }
        });

        aside.on("click", function () {
            $('body').removeClass("open_aside");
        });

        content_aside.on("click", function (e) {
            e.stopPropagation();
        });
    }

    private static _DataTable() {
        const data_table = $('table.data-table');

        if (data_table.find('thead').length > 0) {
            data_table.dataTable({
                "responsive": true,
                "paging": false,
                "searching": false,
                "info": false,
                "ordering": true,
                "order": [[0, "asc"]],
            })
        }
    }

    private static _DragAndDrop() {
        const input = $('#attachment');
        const dropArea = $('.drop-area');
        const preview = $('#previewAttachment');
        const form = $('#integrapedidoform');
        const button = $('.form-button-alt');
        const alert = $('.alert-area');

        input.on('change', function () {
            if (this.files && this.files[0]) {
                loadFiles(this.files);
            }
        });

        dropArea.on('click', function () {
            input.trigger('click');
        });

        dropArea.off('dragenter dragover').on('dragenter dragover', function (e) {
            e.preventDefault();
            e.stopPropagation();
            dropArea.addClass('highligh');
        });

        dropArea.off('dragleave').on('dragleave', function (e) {
            e.preventDefault();
            e.stopPropagation();
            dropArea.removeClass('highligh');
        });

        dropArea.off('drop').on('drop', function (e) {
            e.preventDefault();
            e.stopPropagation();
            dropArea.removeClass('highligh');
            let dt = e.originalEvent.dataTransfer;
            let files = dt.files;
            input.get(0).files = dt.files;
            if (files && files[0]) {
                loadFiles(files);
            }
        });

        preview.find('.remove').on('click', function () {
            hidePreview();
            input.val('');
        });

        const loadFiles = function (files) {

            const load_files = files;
            var reader = new FileReader();

            reader.onload = function (e) {
                displayPreview(load_files);
            }

            reader.readAsDataURL(files[0]); // convert to base64 string
            return;
        };

        const displayPreview = function (file) {
            dropArea.hide();
            preview.show();
            preview.find('.preview-file').text(file[0].name);
            form.find('.download').hide();
            button.show();
            alert.show();
        };

        const hidePreview = function () {
            dropArea.show();
            preview.hide();
            form.find('.download').show();
            button.hide();
            alert.hide();
        };
    }
}
